module.exports = __webpack_public_path__ + "media/images/icon__point--white-6eed5b7e6d590dee6e618358689cb9ef.png";